import React from "react";
import "./Photos.css"

export default function Photos(props){

    if (props.photos && props.photos.length > 0) {
      return (
        <section className="glass-card photos-gallery-section ">
          <h3 clssName="gallery-title-header mb-4"> Visual References</h3>
          <div className="row g-3">
            {props.photos.map(function (photo, index) {
              return (
                <div className="col-10 col-sm-6 col-md-4" key={index}>
                  <a
                    href={photo.url}
                    target="_blank"
                    rel="noreferrer"
                    className="photo-anchor-wrapper"
                  >
                    <div className="img-aspect-box">
                      <img
                        src={photo.src.large}
                        className="img-fluid gallery-photo-element"
                        alt={photo.alt || "Pexels Context Match"}
                      />
                      <div className="photo-author-overlay">
                        <span>📸 {photo.photographer}</span>
                      </div>
                    </div>
                  </a>
                </div>
              );
            })}
          </div>
        </section>
      );
    } else {
      return null;
    }
}